import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { timeout } from 'rxjs';
import { APP_CONFIG } from '../config/app-config.token';

const STAFF_UPLOAD_PATH = /\/staff\/(alta|baja)\/(validar|procesar)(?:\?|$)/;

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const { timeoutMs, uploadTimeoutMs } = inject(APP_CONFIG).http;
  const ms = STAFF_UPLOAD_PATH.test(req.url) ? uploadTimeoutMs : timeoutMs;

  return next(req).pipe(timeout(ms));
};
